export const SET_ESTUDANTE = 'SET_ESTUDANTE';
export const SET_ESTUDANTES = 'SET_ESTUDANTES';
export const SET_ORDENACAO_BUSCA = 'SET_ORDENACAO_BUSCA';
export const SET_PAGINACAO = 'SET_PAGINACAO';
export const SET_UNIDADES = 'SET_UNIDADES';
export const SET_MODALIDADES = 'SET_MODALIDADES';
export const SET_MODELOS_NEGOCIO = 'SET_MODELOS_NEGOCIO';
export const SET_CURSOS = 'SET_CURSOS';
export const SET_VERSOES = 'SET_VERSOES';
export const SET_TURMAS = 'SET_TURMAS';
export const SET_MAX_CH_UNIDADE = 'SET_MAX_CH_UNIDADE';
export const SET_VARIAVEIS_SIMULACAO = 'SET_VARIAVEIS_SIMULACAO';
export const SET_VARIAVEIS_IMPORTANCIA = 'SET_VARIAVEIS_IMPORTANCIA';
export const SET_VARIAVEIS_INFORMACOES = 'SET_VARIAVEIS_INFORMACOES';
export const SET_ESTUDANTE_SIMULACAO = 'SET_ESTUDANTE_SIMULACAO';
export const SET_FORM_SIMULACAO = 'SET_FORM_SIMULACAO';
export const SET_MODELO = 'SET_MODELO';



// WEBPACK FOOTER //
// ./src/pages/estudantes/store/mutations-types.js